import { Routes } from '@angular/router';
import { AuthGuard } from '@shared/guards/auth.guard';
import { clienteGuard } from '@shared/guards/cliente.guard';
import { DbGuard } from '@shared/guards/db.guard';
import { LoginGuard } from '@shared/guards/login.guard';
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@auth/auth.routes').then((m) => m.routes),
    canActivate: [LoginGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/pages.routes').then((m) => m.PagesRoutes),
    canActivate: [AuthGuard, DbGuard, clienteGuard],
  },
  {
    path: 'seleccionar-cliente',
    loadComponent: () => import('@shared/components/filtro-cliente/filtro-cliente.component').then((c) => c.FiltroClienteComponent),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'app/inicio',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app/inicio',
    pathMatch: 'full',
  },
];
